import { useState, useEffect } from "react";
import './onama.css'
import CounterToThousand from "../components/CountetToTousant";
import Do13 from "../components/Do13";



const Onama = () => {

    const  [page, setPage] = useState(null);
    const imageUrl = page?._embedded?.["wp:featuredmedia"]?.[0]?.source_url;

    useEffect(() => {
    const fetchPage = async() => {
      try{
        const response = await fetch(`https://carboncro.hr/wp-json/wp/v2/pages/124?_embed`);
        if(!response.ok){
          throw new Error('Ne mogu povući podatke');
        }
        const data = await response.json();
        setPage(data);

      }catch (err) {
        console.log(err.message);
      }
    }
    fetchPage();



    
  }, []);

  return (

    <>

  

    <div className='container text-center'>
    <section className="about-header">
  <div className="about-overlay">
    <h1>O nama</h1>
    <p>Strast prema automobilima. Preciznost u svakom detalju.</p>
  </div>
</section>

<section className="about-content container">
  <div className="row align-items-center">
    
    <div className="col-lg-6 about-text" >
      <h2>Tko smo mi?</h2>
    <div dangerouslySetInnerHTML={{ __html: page?.content?.rendered }} />
    </div>

    <div className="pic col-lg-6">
      {imageUrl && (
          <img 
            src={imageUrl} 
            alt={page.title.rendered} 
            className="w- 15px rounded-xl mb-4"
          />
)}
    </div>

  </div>
</section>

<section className="about-features justify-content-center">
  <div className="container text-center">
    <div className="row justify-content-center">

      <div className="col-lg-4 text-center">
           
        <div className="feature-box">
          <CounterToThousand />
          <p>Zadovoljnih klijenata diljem Hrvatske.</p>
        </div>
      </div>

      <div className="col-lg-4">
        <div className="feature-box">
          <Do13 />
          <p>Godina iskustva u tapetariiji!</p>
        </div>
      </div>

      <div className="col-lg-4">
        <div className="feature-box">
          <h3>Custom rješenja</h3>
          <p>Svaki projekt je jedinstven i prilagođen vašim željama.</p>
        </div>
      </div>

    </div>
  </div>
</section>
</div>

</>
  )
}

export default Onama
